import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Auth} from '../auth/auth.service';

@Component({
    selector: 'kkk-not-permitted',
    templateUrl: './not-permitted.component.html',
    styles: []
})
export class NotPermittedComponent implements OnInit {

    next: string;

    constructor(
        private auth: Auth,
        private route: ActivatedRoute,
        private router: Router
    ) {
    }

    ngOnInit() {
        this.next = this.route.snapshot.queryParams['n'];
    }

    loginAsOtherUser() {
        this.auth.logOut();
        return this.router.navigate(['/belepes'], {queryParams: {n: this.next}});
    }

}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/not-permitted/not-permitted.component.ts